import content1 from "../assets/100000002156.jpg"
import content2 from "../assets/100000002140.jpg"
import chief from "../assets/cheff-tr.png"
import weeding from "../assets/menu-3.jpg"
import reception from "../assets/menu-2.jpg"
import birthday from "../assets/menu-4.jpg"
import aniversary from "../assets/menu-1.jpg"
import serve_bg from "../assets/bg-counter.jpg"
import booking_bg from "../assets/booking-bg.jpg"
import shape_png from "../assets/shape.png"
import error_img from "../assets/erroor.jpg"
import std_pkg from "../assets/std-pkg.webp"
import delux_pkg from "../assets/delux=pkg.webp"
import exec_pkg from "../assets/exec-pkg.webp"

import wed1 from "../assets/wed1.jpg"
import wed2 from "../assets/wed2.avif"
import wed3 from "../assets/wed3.jpg"
import wed4 from "../assets/wed4.jpg"
import wed5 from "../assets/wed5.jpg"
import wed6 from "../assets/wed6.jpg"
import wed7 from "../assets/wed7.jpg"
import wed8 from "../assets/wed8.jpg"

import rece1 from "../assets/rece1.jpg"
import rece2 from "../assets/rece2.jpg"
import rece3 from "../assets/rece3.jpg"
import rece4 from "../assets/rece4.jpg"
import rece5 from "../assets/rece5.jpg"

import bday1 from "../assets/bday1.jpg"
import bday2 from "../assets/bday2.jpg"
import bday3 from "../assets/bday3.jpg"
import bday4 from "../assets/bday4.jpg"
import bday5 from "../assets/bday5.avif"

import anv1 from "../assets/anv1.jpg"
import anv2 from "../assets/anv2.jpg"
import anv3 from "../assets/anv3.jpg"
import anv4 from "../assets/anv4.jpg"
import anv5 from "../assets/anv5.jpg"



export const assets = {
    content1,
    content2,
    chief,
    serve_bg,
    booking_bg,
    shape_png,
    error_img,
    std_pkg,
    delux_pkg,
    exec_pkg
}

export const event = [
    { name: "Wedding", img: weeding },
    { name: "Reception", img: reception },
    { name: "Birthday Party", img: birthday },
    { name: "Aniversary Party", img: aniversary }
]

export const Events_category = [
    // 🌸 WEDDING
    { id: 1, name: "Wedding", type: "wedding", img: wed1 },
    { id: 2, name: "Wedding", type: "wedding", img: wed2 },
    { id: 3, name: "Wedding", type: "wedding", img: wed3 },
    { id: 4, name: "Wedding", type: "wedding", img: wed4 },
    { id: 5, name: "Wedding", type: "wedding", img: wed5 },
    { id: 6, name: "Wedding", type: "wedding", img: wed6 },
    { id: 7, name: "Wedding", type: "wedding", img: wed7 },
    { id: 8, name: "Wedding", type: "wedding", img: wed8 },

    // 💍 RECEPTION
    { id: 10, name: "Reception", type: "reception", img: rece1 },
    { id: 11, name: "Reception", type: "reception", img: rece2 },
    { id: 12, name: "Reception", type: "reception", img: rece3 },
    { id: 13, name: "Reception", type: "reception", img: rece4 },
    { id: 14, name: "Reception", type: "reception", img: rece5 },

    // 🎂 BIRTHDAY
    { id: 19, name: "Birthday", type: "birthday", img: bday1 },
    { id: 20, name: "Birthday", type: "birthday", img: bday2},
    { id: 21, name: "Birthday", type: "birthday", img: bday3},
    { id: 22, name: "Birthday", type: "birthday", img: bday4},
    { id: 23, name: "Birthday", type: "birthday", img: bday5 },


    // 💖 ANNIVERSARY
    { id: 28, name: "Anniversary", type: "aniversary", img: anv1 },
    { id: 29, name: "Anniversary", type: "aniversary", img: anv2 },
    { id: 30, name: "Anniversary", type: "aniversary", img: anv3 },
    { id: 31, name: "Anniversary", type: "aniversary", img: anv4 },
    { id: 32, name: "Anniversary", type: "aniversary", img: anv5 },

];


